module.exports = __webpack_public_path__ + "img/mazda-5050-half01.09a3f5f4.png";